import { useCallback, useEffect, useState } from 'react';

const minWidthLarge = 1024;
const minWidthMedium = 768;

export function useWindowWidth() {
  const [windowWidthMeasure, setWindowWidthMeasure] = useState('minWidthLarge');

  const handleResize = useCallback(() => {
    const width = window.innerWidth;

    if (width >= minWidthLarge) {
      setWindowWidthMeasure('minWidthLarge');
    } else if (width >= minWidthMedium) {
      setWindowWidthMeasure('minWidthMedium');
    } else {
      setWindowWidthMeasure('maxWidthMedium');
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    handleResize();
    window.addEventListener('resize', handleResize, {
      capture: true,
      passive: true,
    });

    return () => {
      window.removeEventListener('resize', handleResize, { capture: true });
    };
  }, [handleResize]);

  return windowWidthMeasure;
}
